import moment from 'moment';

export const INITIAL_MODAL_STATE = {
  isOpen: false,
  monthlyBudgetReached: false,
  monthlyNumberReached: false
};

export const SILVER_VOUCHER_MONTHLY_BUDGET_ALLOWANCE = 5000;
export const SILVER_VOUCHER_MONTHLY_NUMBER_ALLOWANCE = 20;

export const DISCOUNT = 'DISCOUNT';
export const VOUCHER_DESCRIPTION = {
  SILVER_DISCOUNT: 'Discount - Silver Voucher'
};
export const VOUCHER_TYPE = {
  SILVER_DISCOUNT: 'SILVER_DISCOUNT'
};

export const aYearAndAHalfFromNow = moment().add(1.5, 'year').format('YYYY-MM-DD').toString();
export const twoYearsFromNow = moment().add(2, 'year').format('YYYY-MM-DD').toString();
export const threeMonthsFromNow = moment().add(3, 'months').format('YYYY-MM-DD').toString();

export const calculateSalesPeriodEnd = (salesDateStart) => {
  if (!salesDateStart) return '';
  return moment(salesDateStart).add(1, 'month').format('YYYY-MM-DD');
};

export const calculateTravelPeriodStart = (salesDateStart) => {
  if (!salesDateStart) return '';
  return moment(salesDateStart).add(2, 'months').format('YYYY-MM-DD');
};

export const calculateTravelPeriodEnd = (salesDateStart) => {
  if (!salesDateStart) return '';
  return moment(salesDateStart).add(2, 'months').add(18, 'months').format('YYYY-MM-DD');
};

export const carriers = [
  { name: 'ES', description: 'generateDiscountCode.esCarrier' },
  { name: 'ER', description: 'generateDiscountCode.erCarrier' },
  { name: 'ES_ER', description: 'generateDiscountCode.esPlusErCarrier' }
];
export const classOfServices = [
  { name: 'STANDARD', description: 'Standard / Standard / Standard' },
  { name: 'PLUS', description: 'Standard Premier / Comfort / Eurostar Plus' },
  { name: 'PREMIUM', description: 'Business Premier / Premium / Eurostar Premier' }
];
export const PRODUCTS_RESTRICTION = {
  ES_PUB_STD: 'ES_PUB_STD',
  ESTAR_PUB_STD: 'ESTAR_PUB_STD',
  ESTAR_PUB_WC: 'ESTAR_PUB_WC',
  ER_PUB_STD: 'ER_PUB_STD',
  RED_ESTAR_PUB_STD: 'RED_ESTAR_PUB_STD',
  RED_ESTAR_PUB_WC: 'RED_ESTAR_PUB_WC',
  ESTAR_PUB_PLUS: 'ESTAR_PUB_PLUS',
  ES_PUB_SP: 'ES_PUB_SP',
  ER_PUB_COMF: 'ER_PUB_COMF',
  RED_ESTAR_PUB_PLUS: 'RED_ESTAR_PUB_PLUS',
  ESTAR_PUB_PREM: 'ESTAR_PUB_PREM',
  RED_ESTAR_PUB_PREM: 'RED_ESTAR_PUB_PREM'
};

export const MAP_CARRIER_AND_COS_TO_PRODUCTS_RESTRICTION = {
  ES: {
    STANDARD: [PRODUCTS_RESTRICTION.ES_PUB_STD, PRODUCTS_RESTRICTION.ESTAR_PUB_STD, PRODUCTS_RESTRICTION.ESTAR_PUB_WC],
    PLUS: [PRODUCTS_RESTRICTION.ES_PUB_SP, PRODUCTS_RESTRICTION.ESTAR_PUB_PLUS, PRODUCTS_RESTRICTION.ESTAR_PUB_WC],
    PREMIUM: [PRODUCTS_RESTRICTION.ESTAR_PUB_PREM, PRODUCTS_RESTRICTION.ESTAR_PUB_WC]
  },
  ER: {
    STANDARD: [PRODUCTS_RESTRICTION.ER_PUB_STD, PRODUCTS_RESTRICTION.RED_ESTAR_PUB_STD, PRODUCTS_RESTRICTION.RED_ESTAR_PUB_WC],
    PLUS: [PRODUCTS_RESTRICTION.ER_PUB_COMF, PRODUCTS_RESTRICTION.RED_ESTAR_PUB_PLUS, PRODUCTS_RESTRICTION.RED_ESTAR_PUB_WC],
    PREMIUM: [PRODUCTS_RESTRICTION.RED_ESTAR_PUB_PREM, PRODUCTS_RESTRICTION.RED_ESTAR_PUB_WC]
  },
  ES_ER: {
    STANDARD: [
      PRODUCTS_RESTRICTION.ES_PUB_STD,
      PRODUCTS_RESTRICTION.ESTAR_PUB_STD,
      PRODUCTS_RESTRICTION.ESTAR_PUB_WC,
      PRODUCTS_RESTRICTION.ER_PUB_STD,
      PRODUCTS_RESTRICTION.RED_ESTAR_PUB_STD,
      PRODUCTS_RESTRICTION.RED_ESTAR_PUB_WC
    ],
    PLUS: [
      PRODUCTS_RESTRICTION.ES_PUB_SP,
      PRODUCTS_RESTRICTION.ESTAR_PUB_PLUS,
      PRODUCTS_RESTRICTION.ESTAR_PUB_WC,
      PRODUCTS_RESTRICTION.ER_PUB_COMF,
      PRODUCTS_RESTRICTION.RED_ESTAR_PUB_PLUS,
      PRODUCTS_RESTRICTION.RED_ESTAR_PUB_WC
    ],
    PREMIUM: [
      PRODUCTS_RESTRICTION.ESTAR_PUB_PREM,
      PRODUCTS_RESTRICTION.ESTAR_PUB_WC,
      PRODUCTS_RESTRICTION.RED_ESTAR_PUB_PREM,
      PRODUCTS_RESTRICTION.RED_ESTAR_PUB_WC
    ]
  }
};

export const TRIP_RESTRICTIONS = [
  { name: 'ONE_WAY_TRIP', description: 'oneWayJourney' },
  { name: 'RETURN_TRIP', description: 'returnJourney' }
];

export const COUNTRIES_RESTRICTIONS = ['GB', 'NL', 'FR', 'DE', 'BE', 'ES_ER'];
export const DE_COUNTRY = 'DE';
export const NL_COUNTRY = 'NL';
export const INCLUDE_ES_ER = 'ES_ER';
